import { Resource } from "../../../resources/types";
import {
  ResourceHiddenInput,
  ResourceHiddenInputProps,
} from "./ResourceHiddenInput";

export const ResourceHiddenTextInput = <TResource extends Resource>(
  props: ResourceHiddenInputProps<TResource>
) => <ResourceHiddenInput defaultValue="" {...props} />;
